module.exports = __webpack_public_path__ + "static/8-6e1262882097338aff8e76b1da851572.png";